import React from 'react';
import { graphql } from 'gatsby';
import { CardCarousel as CardCarouselComponent } from '../../CardCarousel';

export const CardCarousel = ({ data, ...rest }) => <CardCarouselComponent {...data} {...rest} />;

export const CardCarouselQuery = graphql`
  fragment CardCarousel on KFH_UmbracoCardCarouselComponentType {
    title
    button {
      ...Button
    }
    items {
      heading
      text
      image {
        altText
        localFile {
          gatsbyImage(width: 512, layout: CONSTRAINED, placeholder: NONE, quality: 80, backgroundColor: "#F5F5F5")
        }
      }
    }
  }
`;
